import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'marketplace-dialog.common.in-progress-status.heading',
		defaultMessage: 'Installing the {appName} app...',
		description:
			'The heading of the modal that shows the in-progress installation of a Marketplace app',
	},
	body: {
		id: 'marketplace-dialog.common.in-progress-status.body',
		defaultMessage: "Sit back and relax. We'll be done in a few more seconds.",
		description:
			'The body of the modal that shows the in-progress installation of a Marketplace app',
	},
});
